import { render, staticRenderFns } from "./mallCouponReceiveLog.vue?vue&type=template&id=d72579f0"
import script from "./mallCouponReceiveLog.vue?vue&type=script&lang=js"
export * from "./mallCouponReceiveLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports